/* ============================================================
   CUSTOM PERSO JS V1 - Les Enfants Sauvages
   ============================================================
   But : appliquer les modifs DOM cote navigateur, pour ne pas
   editer les fichiers liquid natifs Prestige (qui seraient
   ecrases a chaque update Maestrooo).

   Modifs effectuees :
   1. Product cards : deplacer .rating-badge entre .product-title
      et le price-list (au lieu du bas de .product-card__info)
   2. (Futur) Header : remplacer <shopify-account> par lien Compte
   3. (Futur) Product rating : forcer le format X avis

   Tous les changements sont declenchent au DOMContentLoaded, et
   re-appliques via MutationObserver pour gerer le chargement
   dynamique (Yotpo, quick-buy, theme editor preview, etc.).
   ============================================================ */

(function () {
  'use strict';

  /**
   * Pour une product-card, reorganise pour avoir title -> rating -> price
   * (par defaut Prestige v4 = title -> price -> rating au bas)
   */
  function reorderProductCard(card) {
    if (!card || card.dataset.lesRatingReordered === '1') return;

    var info = card.querySelector('.product-card__info');
    if (!info) return;

    var rating = info.querySelector(':scope > .rating-badge');
    if (!rating) return;

    // Chercher le v-stack interne qui contient le title + price-list
    var innerStack = info.querySelector('.v-stack .v-stack:has(.product-title), .v-stack .v-stack:has(price-list)');
    if (!innerStack) {
      // fallback : prendre le premier v-stack qui contient .product-title
      var stacks = info.querySelectorAll('.v-stack');
      for (var i = 0; i < stacks.length; i++) {
        if (stacks[i].querySelector('.product-title')) {
          innerStack = stacks[i];
          break;
        }
      }
    }
    if (!innerStack) return;

    var priceList = innerStack.querySelector('price-list, .price-list');
    if (!priceList) return;

    // Inserer .rating-badge juste avant price-list
    innerStack.insertBefore(rating, priceList);
    card.dataset.lesRatingReordered = '1';
  }

  /**
   * Applique reorderProductCard a toutes les cards de la page
   */
  function reorderAllProductCards(root) {
    var scope = root || document;
    var cards = scope.querySelectorAll('product-card, .product-card');
    for (var i = 0; i < cards.length; i++) {
      reorderProductCard(cards[i]);
    }
  }

  // Lancement initial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { reorderAllProductCards(); });
  } else {
    reorderAllProductCards();
  }

  // Re-appliquer apres chargement complet (Yotpo et autres async)
  window.addEventListener('load', function () { reorderAllProductCards(); });

  // Observer pour le contenu ajoute dynamiquement (quick-buy, theme editor, etc.)
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];
      for (var j = 0; j < mutation.addedNodes.length; j++) {
        var node = mutation.addedNodes[j];
        if (node.nodeType !== 1) continue; // element only
        if (node.matches && node.matches('product-card, .product-card')) {
          reorderProductCard(node);
        } else if (node.querySelectorAll) {
          reorderAllProductCards(node);
        }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Theme editor : ecouter les events de Shopify
  document.addEventListener('shopify:section:load', function (e) { reorderAllProductCards(e.target); });
  document.addEventListener('shopify:block:select', function (e) { reorderAllProductCards(e.target); });
})();
